/* PW Card Co - polish layer behaviour: header shadow + hide-on-scroll (mobile). */
(function () {
  'use strict';
  var body = document.body;
  if (!body) return;
  var mq = window.matchMedia('(max-width: 749px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var lastY = window.pageYOffset || 0;
  var ticking = false;
  var hidden = false;
  var TOP_ZONE = 140;
  var DELTA = 8;

  function overlayOpen() {
    if (document.querySelector('#Details-menu-drawer-container[open], dialog[open], .pw-filters.is-open')) return true;
    var h = document.getElementById('header-component');
    return !!(h && h.contains(document.activeElement) && document.activeElement !== document.body);
  }
  function setHidden(v) {
    if (v === hidden) return;
    hidden = v;
    body.classList.toggle('pwp-header-hidden', v);
  }
  function update() {
    ticking = false;
    var y = window.pageYOffset || 0;
    body.classList.toggle('pwp-scrolled', y > 8);
    if (!mq.matches || reduce.matches || y < TOP_ZONE || overlayOpen()) {
      setHidden(false);
    } else if (y - lastY > DELTA) {
      setHidden(true);
    } else if (lastY - y > DELTA) {
      setHidden(false);
    } else {
      return;
    }
    lastY = y;
  }
  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  document.addEventListener('focusin', function () { setHidden(false); });
  update();
})();

/* Performance (round 16): pause looping CSS animations in sections that are off screen, and everything when
   the tab is hidden. See the matching rules at the end of pwc-polish.css. */
(function () {
  var root = document.documentElement;
  document.addEventListener('visibilitychange', function () {
    root.classList.toggle('pw-tab-hidden', document.hidden);
  });
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('pw-paused', !e.isIntersecting);
      });
    },
    { rootMargin: '150px 0px' }
  );
  function watch() {
    document.querySelectorAll('.shopify-section').forEach(function (s) {
      if (!s.__pwWatched) { s.__pwWatched = true; io.observe(s); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
